import { render, staticRenderFns } from "./tableLink.vue?vue&type=template&id=e071c8a2&scoped=true"
import script from "./tableLink.vue?vue&type=script&lang=js"
export * from "./tableLink.vue?vue&type=script&lang=js"
import style0 from "./tableLink.vue?vue&type=style&index=0&id=e071c8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e071c8a2",
  null
  
)

export default component.exports